import { FC, memo, useCallback, useState } from 'react'

import { Text, AttentionCircleIcon, CloseIcon } from '@cash-me/react-components'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { Grid, Col } from 'components/grid'
import useLocalStorage from 'hooks/useLocalStorage'

import * as S from './styles'

interface WarningProps {
  $darkMode?: boolean
}

const Warning: FC<WarningProps> = memo(({ $darkMode = false }) => {
  const router = useRouter()
  const { setItem } = useLocalStorage()

  const [showWarning, setShowWarning] = useState(true)

  const handleCloseWarning = useCallback(() => {
    setItem('cashme-warning', new Date())
    setShowWarning(false)
  }, [setItem])

  if (!showWarning) return <></>

  const colorIcon = $darkMode ? 'var(--colors-neutral-icon-default)' : 'var(--colors-blue-icon-strong)'
  const colorText = $darkMode ? 'var(--colors-neutral-text-default)' : 'var(--colors-neutral-text-contrast-default)'

  return (
    <S.WarningWrap $darkMode={$darkMode}>
      <Grid col={{ phone: 1, tablet: 1 }}>
        <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
          <S.Warning>
            <S.Content>
              <AttentionCircleIcon size={24} color={colorIcon} />
              <Text size="body1" color={colorText}>
                A CashMe {' '}
                <Text as="span" size="body1" weight="bold" color={colorText}>
                  não solicita 
                </Text> {' '}
                depósito ou pagamento antecipado para aprovação de crédito.
              </Text>
            </S.Content>
            <div>
              {router.pathname !== '/seguranca' && 
                <Link href="/seguranca" prefetch={false}>
                  Evite Golpes
                </Link>
              }
              <S.Close aria-label="Fechar aviso" onClick={handleCloseWarning}>
                <CloseIcon size={24} color="var(--colors-neutral-icon-default)" />
              </S.Close>
            </div>
          </S.Warning>
        </Col>
      </Grid>
    </S.WarningWrap>
  )
})

Warning.displayName = 'Warning'

export default Warning
